import { render, staticRenderFns } from "./choosecontacts.vue?vue&type=template&id=4bf4694c&scoped=true"
import script from "./choosecontacts.vue?vue&type=script&lang=js"
export * from "./choosecontacts.vue?vue&type=script&lang=js"
import style0 from "./choosecontacts.vue?vue&type=style&index=0&id=4bf4694c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf4694c",
  null
  
)

export default component.exports